import { render } from "./WorkOrders.vue?vue&type=template&id=4631d9a0"
import script from "./WorkOrders.vue?vue&type=script&lang=js"
export * from "./WorkOrders.vue?vue&type=script&lang=js"

import "./WorkOrders.vue?vue&type=style&index=0&id=4631d9a0&lang=scss"

import exportComponent from "/codebuild/output/src911820074/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__